import React from "react";
import { useTranslation } from "react-i18next";
import { useProdaName } from "../../hooks/useProdaName";
import BookingStateValueInfo from "../booking/BookingStateValueInfo";
import { PriceDataHelper } from "./PriceDataHelper";
import { useTranslationEx } from "../../hooks/useTranslationEx";
const findPdh = (
  pdh: InstanceType<typeof PriceDataHelper> | undefined,
  id: string | number | undefined,
) =>
  pdh?.ls?.find((x) => x.currentBState?.product?.id === id)?.currentBState
    ?.childrenLs ?? [];
export const BookingCardInfo = ({
  priceDataHelper,
  readonly = false,
}: {
  priceDataHelper: InstanceType<typeof PriceDataHelper>;
  readonly?: boolean;
}) => {
  const { t } = useTranslation();
  const { t2 } = useTranslationEx();
  const { showAgeLs } = useProdaName();
  return (
    <>
      <aside className="booking-card-info space-y-5 border-t border-[#DEDEDE] py-5">
        {priceDataHelper.ls.map(({ currentBPrice, currentBState }, index) => {
          if (!currentBPrice) return null;
          return (
            <React.Fragment
              key={JSON.stringify({ currentBPrice, currentBState })}
            >
              {priceDataHelper.isPass() ? (
                <div className="flex items-center justify-between">
                  <h2 className="text-base font-semibold leading-[1.625rem] text-[#232323]">
                    {showAgeLs(currentBState)}
                  </h2>
                  {currentBPrice?.pakage && (
                    <p className="h-[1.375rem] text-sm font-normal leading-[1.375rem] text-[#232323]">
                      {t2(currentBPrice?.pakage?.name)}
                    </p>
                  )}
                </div>
              ) : (
                <>
                  <h2 className="text-base font-semibold leading-[1.625rem] text-[#232323]">
                    {t("Product")}
                  </h2>
                  {currentBPrice?.pakage && (
                    <p className="h-[1.375rem] text-sm font-normal leading-[1.375rem] text-[#232323]">
                      {t2(currentBPrice?.pakage?.name)}
                    </p>
                  )}
                </>
              )}

              <BookingStateValueInfo
                vari="BOOKING_CARD"
                booking={currentBState}
                readonly={readonly}
              />
            </React.Fragment>
          );
        })}
      </aside>
    </>
  );
};
